// extracted by mini-css-extract-plugin
export default {"sbtH3":"SbtH3_sbtH3__iJQkk"};